import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import lodash from 'lodash';

// Reuse existing Redux actions and components
import {
  getContactCompanyList,
  getOrgPaymentMethodList,
  saveSelectedCustomers,
  saveNewSelectedPaymentMethod,
  handleCurrentStep,
  saveToHistory,
  setBusinessBlockFlag,
  resetState,
  onlyMobileML,
  setIsPrivateDefaultAreSelected,
  setProgressBarPercent,
} from '../UpdatePaymentMethodBlock/updatePaymentMethodSlice';
import SelectCustomersComponent from '../UpdatePaymentMethodBlock/SelectCustomers/SelectCustomersComponent';
import SimpleSmsComponent from './SimpleSmsComponent';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import HeadLineComponent from '../UpdatePaymentMethodBlock/HeadLineComponent';

import Config from '../../../Config';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import Loader from '../../Shared/Loader/Loader';
import { gaReportOnButtonClick, gaClickNumOfMethods } from '../UpdatePaymentMethodBlock/gaReports';
import { createReport } from '../../../utilities/reports/createReport';
import { reportDWHBuilder } from '../EntityPaymentBlock/reportDWH';

const FlowToEntityPayment = (props) => {
  const [currentView, setCurrentView] = useState('accounts');
  const [selectedAccountsData, setSelectedAccountsData] = useState(null);
  const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);
  const [accountLoadError, setAccountLoadError] = useState(null);

  useEffect(() => {
    const isBusiness = props.cmsData?.isBusinessBlock?.value || false;
    const blockId = props.cmsData?.contentLink?.id;

    if (props.setBusinessBlockFlag) {
      props.setBusinessBlockFlag({ isBusiness, blockId });
    }

    const loadInitialData = async () => {
      try {
        if (!props.data?.orgDetailList || props.data.orgDetailList.length === 0) {
          await props.getContactCompanyList();
        }
      } catch (error) {
        console.error('Error loading initial account data:', error);
        setAccountLoadError('שגיאה בטעינת נתוני החשבונות');
      }
    };

    loadInitialData();

    // DWH Report: Component loaded
    const reportData = reportDWHBuilder(
      'FLOW_TO_ENTITY_PAYMENT_COMPONENT_LOADED',
      {
        IdNumber: props.IdNumber,
        isBusinessUser: isBusiness,
        Customer_Name: (props.data?.contactFirstName || '') + ' ' + (props.data?.contactLastName || ''),
        ID_NUMBER: props.IdNumber,
        SUBSCRIBER: props.data?.contactPhoneNumber || props.mobile,
        blockId: blockId,
      },
      props,
    );
    createReport(reportData);
  }, []);

  useExtendedEffect((runSideEffects) => {
    return () => {
      if (props.resetState) {
        props.resetState();
      }
    };
  }, []);

  const backToLobby = async () => {
    try {
      const lobbyUrl = Config.lobbyUrl;
      let content = await props.context.loadContentByPath(lobbyUrl);
      props.context.navigateTo(content);
    } catch (error) {
      console.error('Error navigating to lobby:', error);
    }
  };

  //step 2
  const setSelectedForUpdate = (idNumber, selectedProvider) => {
    if (idNumber != undefined && selectedProvider != undefined && props.data.isBusinessBlock) {
      const isPrivateUserFlow = props.data.isBusinessBlock ? false : props.data.isBusinessBlock;
      props.getOrgPaymentMethodList({ idNumber, selectedProvider, isPrivateUserFlow })
        .catch(error => {
          console.error('Error loading payment methods:', error);
          setAccountLoadError('שגיאה בטעינת נתוני החשבונות');
          setIsLoadingAccounts(false);
        });
    }
  };

  //step 3
  const setSelectedCustomers = (dataWithSelectedCustomers) => {
    let selectedPayments = 0;
    let selectedInvoices = 0;
    dataWithSelectedCustomers.map((data) => {
      let selectedInvoicesCount = lodash.filter(data.customersList, function (customer) {
        return customer.checked == true;
      }).length;

      if (selectedInvoicesCount > 0) {
        ++selectedPayments;
        selectedInvoices += selectedInvoicesCount;
      }
    });
    if (props.data.isBusinessBlock) {
      gaReportOnButtonClick('all_payment_methods_continue_to_the_next_step_btn');
      gaClickNumOfMethods(selectedPayments);
    }

    props.saveSelectedCustomers({ dataWithSelectedCustomers, selectedPayments, selectedInvoices });
  };

  useEffect(() => {
    if (
      currentView === 'accounts' &&
      props.IdNumber &&
      !props.data?.selectedForUpdate &&
      !isLoadingAccounts &&
      !props.data?.isLoading &&
      props.data?.isBusinessBlock !== undefined &&
      (props.data.isBusinessBlock ? (props.data?.orgDetailList && props.data.orgDetailList.length > 0) : true)
    ) {
      setIsLoadingAccounts(true);
      setAccountLoadError(null);

      if (props.data.isBusinessBlock) {
        setSelectedForUpdate(props.IdNumber, 'Cellcom');
      } else {
        const data = {idNumber: props.IdNumber, selectedProvider: 'Cellcom', isPrivateUserFlow: true};
        props.getOrgPaymentMethodList(data)
          .catch(error => {
            console.error('Error loading payment methods:', error);
            setAccountLoadError('שגיאה בטעינת נתוני החשבונות');
          }).finally(() => {
            setIsLoadingAccounts(false);
          });
      }
    }
  }, [currentView, props.data?.orgDetailList, props.IdNumber, props.data?.selectedForUpdate, isLoadingAccounts, props.data?.isLoading, props.data?.isBusinessBlock]);

  useEffect(() => {
    if (props.data?.selectedForUpdate && isLoadingAccounts) {
      setIsLoadingAccounts(false);

      // DWH Report: Payment methods loaded successfully
      const reportData = reportDWHBuilder(
        'FLOW_TO_ENTITY_PAYMENT_METHODS_LOADED',
        {
          IdNumber: props.IdNumber,
          isBusinessUser: props.data?.isBusinessBlock || false,
          numberOfPaymentMethods: props.data?.selectedForUpdate?.customersPaymentData?.length || 0,
          Customer_Name: (props.data?.contactFirstName || '') + ' ' + (props.data?.contactLastName || ''),
          ID_NUMBER: props.IdNumber,
          SUBSCRIBER: props.data?.contactPhoneNumber || props.mobile,
          paymentMethodTypes: props.data?.selectedForUpdate?.customersPaymentData?.map(pm => pm.paymentMethodType).join(',') || '',
        },
        props,
      );
      createReport(reportData);
    }
  }, [props.data?.selectedForUpdate]);

  useEffect(() => {
    if (isLoadingAccounts && !props.loader?.isLoading) {
      props.showAppLoader();
    } else {
      if (props.loader?.isLoading && !isLoadingAccounts) {
        setTimeout(() => {
          props.hideAppLoader();
        }, 300);
      }
    }
  }, [isLoadingAccounts, props.loader?.isLoading]);

  const handleAccountSelection = (dataWithSelectedCustomers) => {
    setSelectedCustomers(dataWithSelectedCustomers);
    setSelectedAccountsData(dataWithSelectedCustomers);

    // DWH Report: Account selection
    const getSelectedAccounts = () => {
      const result = [];
      dataWithSelectedCustomers.forEach((paymentData) => {
        if (paymentData.customersList) {
          paymentData.customersList.forEach((customer) => {
            if (customer.checked === true) {
              result.push({
                number: customer.number || customer.id,
                name: customer.name || '',
              });
            }
          });
        }
      });
      return result;
    };

    const reportData = reportDWHBuilder(
      'FLOW_TO_ENTITY_PAYMENT_ACCOUNTS_SELECTED',
      {
        accountsSelected: getSelectedAccounts()
          .map((item) => item.number)
          .join(','),
        numberOfAccounts: getSelectedAccounts().length,
        IdNumber: props.IdNumber,
        isBusinessUser: props.data?.isBusinessBlock || false,
        Customer_Name: (props.data?.contactFirstName || '') + ' ' + (props.data?.contactLastName || ''),
        BAN: getSelectedAccounts()
          .map((item) => item.number)
          .join(','),
        ID_NUMBER: props.IdNumber,
        SUBSCRIBER: props.data?.contactPhoneNumber || props.mobile,
      },
      props,
    );
    createReport(reportData);
  };

  const handleStepTransition = (step) => {
    try {
      setCurrentView('sms');

      // DWH Report: Transition to SMS step
      const getSelectedAccountsForSMS = () => {
        const result = [];
        if (selectedAccountsData) {
          selectedAccountsData.forEach((paymentData) => {
            if (paymentData.customersList) {
              paymentData.customersList.forEach((customer) => {
                if (customer.checked === true) {
                  result.push({
                    number: customer.number || customer.id,
                    name: customer.name || '',
                  });
                }
              });
            }
          });
        }
        return result;
      };

      const reportData = reportDWHBuilder(
        'FLOW_TO_ENTITY_PAYMENT_SMS_STEP',
        {
          accountsToUpdate: getSelectedAccountsForSMS()
            .map((item) => item.number)
            .join(','),
          numberOfAccounts: getSelectedAccountsForSMS().length,
          IdNumber: props.IdNumber,
          isBusinessUser: props.data?.isBusinessBlock || false,
          Customer_Name: (props.data?.contactFirstName || '') + ' ' + (props.data?.contactLastName || ''),
          BAN: getSelectedAccountsForSMS()
            .map((item) => item.number)
            .join(','),
          ID_NUMBER: props.IdNumber,
          SUBSCRIBER: props.data?.contactPhoneNumber || props.mobile,
        },
        props,
      );
      createReport(reportData);
    } catch (error) {
      console.error('Error in handleStepTransition:', error);
      setAccountLoadError('שגיאה במעבר לשלב SMS');
    }
  };

    return (
    <div className={`flow-to-entity-payment-main update-payment-method-main-component ${props.data?.isLoading ? 'isLoading' : ''} ${!props.data?.isBusinessBlock ? 'payment-private-flow' : ''} ${isMobile ? 'isMobile' : ''}`}>
      <Container className={`${isMobile ? 'mobile-container' : 'pr-0 pl-0'} m-auto`}>
        <Row>
          <Col xs={12} className='mr-auto ml-auto'>


            {currentView === 'accounts' && (
              <div className="accounts-view">

                <Loader />

                {accountLoadError && (
                  <div className="text-center p-4">
                    <p className="text-danger">{accountLoadError}</p>
                    <BtnSubmit
                      text="נסה שוב"
                      onclick={() => {
                        setAccountLoadError(null);
                        window.location.reload();
                      }}
                    />
                  </div>
                )}

                 {props.data?.selectedForUpdate && !isLoadingAccounts && !accountLoadError && (
                   <SelectCustomersComponent
                     props={{
                       ...props,
                       data: {
                         ...props.data,
                         currentStep: 3
                       },
                       handleCurrentStep: handleStepTransition,
                       saveNewSelectedPaymentMethod: props.saveNewSelectedPaymentMethod || (() => {}),
                       saveToHistory: props.saveToHistory || (() => {}),
                       setIsPrivateDefaultAreSelected: props.setIsPrivateDefaultAreSelected,
                       setProgressBarPercent: props.setProgressBarPercent
                     }}
                     setSelectedCustomers={handleAccountSelection}
                     backToLobby={backToLobby}
                   />
                 )}

                {!props.data?.selectedForUpdate && !isLoadingAccounts && !accountLoadError && currentView === 'accounts' && (
                  <div className="text-center p-4">
                    <p>לא נמצאו חשבונות זמינים לעדכון</p>
                  </div>
                )}
              </div>
            )}

        {currentView === 'sms' && (
          <div className="sms-view">
            <SimpleSmsComponent
              data={props.data}
              IdNumber={props.IdNumber}
              mobile={props.mobile}
              isPrivate={props.isPrivate}
              cmsData={props.cmsData}
              context={props.context}
              onBack={() => setCurrentView('accounts')}
            />
          </div>
        )}

      </Col>
    </Row>
  </Container>
</div>
);
};

const mapStateToProps = (state) => {
  return {
    data: state.updatePayment,
    loader: state.loader,
    IdNumber: state.authentication?.loginData?.userDetails?.IDNumber,
    mobile: state.authentication?.loginData?.userDetails?.contactNumber,
    isPrivate: state.authentication?.loginData?.userDetails?.isPrivate,
    selfcarePage: state.selfcarePage || {},
  };
};

const mapDispatchToProps = {
  getContactCompanyList,
  getOrgPaymentMethodList,
  saveSelectedCustomers,
  saveNewSelectedPaymentMethod,
  handleCurrentStep,
  saveToHistory,
  setBusinessBlockFlag,
  resetState,
  onlyMobileML,
  setIsPrivateDefaultAreSelected,
  setProgressBarPercent,
  // Loader actions
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowToEntityPayment);
